import { required, optional, array, obj } from 'AppReact/schema';

const property = {
  icon: optional('string'),
  logo: optional('string'),
  id: required('integer'),
  name: required('string')
}

const unit = {
  area: optional('integer'),
  floor_plan: optional('string'),
  id: required('integer'),
  number: required('string'),
  status: optional('string'),
  occupancy_status: optional('string')
}

const attachment = {
  url: required('string'),
  content_type: required('string'),
  uuid: required('string'),
}

const attachmentWithId = {
  url: required('string'),
  id: required('integer'),
  content_type: required('string'),
  uuid: required('string'),
}

const event = {
  id: required('integer'),
  event_name: required('string'),
  description: optional('string'),
  description_history: array('string'),
  attachments: array(obj(attachment)),
  created_by: optional('string'),
  datetime: optional('jsDate')
}

export const cardItem = {
  completed: optional('jsDate'),
  completed_by: optional('string'),
  confirmation: optional('string'),
  id: required('integer'),
  request_id: optional('integer'),
  events: array(obj(event)),
  name: optional('string'),
  logo: optional('string'),
  notes: optional('string'),
  scheduled: optional('jsDate'),
  status: optional('string'),
  tech: optional('string'),
  tech_image: optional('string'),
  vendor: optional('string'),
  vendor_url: optional('string'),
  tech_id: optional('integer'),
  vendor_id: optional('integer')
}

export const cardData = {
  attachments: array(obj(attachmentWithId)),
  card_id: required('integer'),
  category_id: required('integer'),
  data: optional('string'),
  id: required('integer'),
}

export default {
  admin: required('string'),
  completed_on: optional('jsDate'),
  completed_by: optional('string'),
  deadline: optional('jsDate'),
  hidden: required('boolean'),
  id: required('integer'),
  inserted_at: required('jsDate'),
  card_data: array(obj(cardData)),
  items: array(obj(cardItem)),
  move_in_date: optional('jsDate'),
  move_out_date: optional('jsDate'),
  priority: optional('integer'),
  property: obj(property),
  unit: obj(unit),
  disabled_categories: array('string')
}
